import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import renderField from '../../../shared/components/custom/Field';
import { partial } from '../../../util/translation/translation';
import validateGuestParticipants from './validateGuestParticipants';

const GuestCardForm = ({ handleSubmit, participant, initialize }) => {
  const p = partial('EventParticipantsPage');
  const s = partial('shared');

  useEffect(() => {
    if (participant) {
      initialize({
        firstName: participant.firstname,
        lastName: participant.lastname,
        phoneNumber: participant.phoneNumber,
        email: participant.email,
        comments: participant.additionalNotes,
        guestAmount: participant.friendAmount,
      });
    }
  }, [participant]);

  const fields = [
    { name: 'firstName', label: s('firstname') },
    { name: 'lastName', label: s('lastname') },
    { name: 'phoneNumber', label: s('phone'), type: 'tel' },
    { name: 'email', label: s('email'), type: 'email' },
  ];

  return (
    <form className="form invite-modal__form" onSubmit={handleSubmit}>
      {fields.map(({ name, label, type }) => (
        <div className="form__form-group" key={name}>
          <span className="form-header">{label}</span>
          <Field
            name={name}
            placeholder={label}
            component={renderField}
            type={type || 'text'}
          />
        </div>
      ))}
      <div className="form__form-group">
        <span className="form-header">{p('numberOfGuests')}</span>
        <Field
          name="guestAmount"
          placeholder={p('chooseGuests')}
          component={renderField}
          type="number"
        />
      </div>
      <div className="form__form-group invite-modal__full">
        <span className="form-header">{s('comments')}</span>
        <Field
          name="comments"
          placeholder={s('comments')}
          component={renderField}
        />
      </div>
      <div className="invite-modal__footer">
        <Button color="primary" type="submit" size="sm" className="mb-0">
          {participant ? s('save') : p('invite')}
        </Button>
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'GuestCardForm',
  validate: validateGuestParticipants,
});

export default connect()(reduxF(GuestCardForm));
